import React from "react";

const DEFAULT_COLOR = "#1e63cb";

const useThemeColor = (color: string | null) => {
    React.useEffect(() => {
        const meta = document.querySelector("meta[name='theme-color']");

        if(!meta || !color) {
            return;
        }

        const original = meta.getAttribute("content") || DEFAULT_COLOR;
        meta.setAttribute("content", color);

        return () => {
            meta.setAttribute("content", original);
        };
    }, [color]);
};

export default useThemeColor;
